/* @flow weak */
import { LoadingInput } from 'components/DecoratedInput.jsx';
import Button from 'components/Button.jsx';
import CardInput from './CardInput.jsx';
import cx from 'classnames';
import PaymentSourceActions from 'payments/actions/PaymentSourceActions';
import React from 'react';
import SettingsStore from 'stores/SettingsStore';
import StripeAPI from 'lib/StripeAPI';
import ToastActions from 'actions/ToastActions';
import EncryptionNotice from 'components/EncryptionNotice.jsx';

import './styles/PaymentSourceForm.scss';

const PaymentSourceForm = React.createClass({
  propTypes: {
    onCreated: React.PropTypes.func.isRequired,
  },

  getInitialState() {
    return {
      card: null,
      loadingScript: true,
    };
  },

  componentDidMount() {
    StripeAPI.setPublishableKey(SettingsStore.getStripeKey())
      .then(this.handleScriptLoaded, this.handleScriptError);
  },

  onSubmit() {
    StripeAPI.createCardToken({
      number: this.state.card.number.value,
      cvc: this.state.card.cvc.value,
      exp: this.state.card.expiry.value,
      address_zip: this.state.card.zip.value,
    }, (status, response) => {
      if (response.error) {
        ToastActions.showErrorToast(response.error.message);
      } else {
        this.createdPaymentSourceFromToken(response.id);
      }
    });
  },

  createdPaymentSourceFromToken(token) {
    PaymentSourceActions
      .create(token)
      .then(
        this.props.onCreated,
        ToastActions.showAPIError,
      );
  },

  handleScriptError() {
    // TODO
  },

  handleScriptLoaded() {
    this.setState({ loadingScript: false });
  },

  renderCardInput() {
    if (this.state.loadingScript) {
      return <LoadingInput />;
    }

    return (
      <CardInput
        placeholder="Enter your debit or credit card"
        onValid={card => this.setState({ card })}
        onInvalid={() => this.setState({ card: null })}
      />
    );
  },

  render() {
    const { className } = this.props;

    return (
      <div className={cx('PaymentSourceForm', className)}>
        {this.renderCardInput()}

        <Button
          className="PaymentSourceForm-submit"
          onClick={this.onSubmit}
          disabled={!this.state.card}
          eventElementName="PaymentSourceForm-submit">
          Add card
        </Button>

        <EncryptionNotice className="PaymentSourceForm-notice" />
      </div>
    );
  },
});

export default PaymentSourceForm;



// WEBPACK FOOTER //
// ./src/payments/components/PaymentSourceForm.jsx